import { IJsonRPCError } from "../types/IJsonRPCError";

export const truncateFromCenter = (value: string): string => {
    return value.substring(0, 8) + '...' + value.substring(value.length - 3, value.length);
}

export const numberWithCommas = (x: any) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const catchErrorMessage = (error: IJsonRPCError) => {
    console.log('catchErrorMessage', error)
    const message = error.data ? error.data.message : error.message;
    if (message.indexOf("Reached max supply") >= 0) {
        return 'Reached max supply';
    }
    if (message.indexOf("Reached max mint") >= 0) {
        return 'Reached max mint';
    }
    if (message.indexOf("Invalid signature") >= 0) {
        return 'Invalid signature, wallet is not whitelisted';
    }
    if (message.indexOf("Reached max mint per tx") >= 0) {
        return 'Reached max mint per transaction';
    }
    if (message.indexOf("ETH sent is incorrect") >= 0) {
        return 'ETH sent is in-correct';
    }
    return message;
}